import '../style/video-B4iy6kf1.css'
import { defineComponent as f, ref as s, computed as y, onMounted as w, openBlock as n, createElementBlock as a, createElementVNode as p, createCommentVNode as d, createTextVNode as v, createBlock as g, unref as k, mergeProps as b } from "vue";
import { useElementSize as B } from "@vueuse/core";
import _ from "./skeleton.js";
const P = ["loop", "muted", "autoplay", "width", "height", "poster", "controls"], S = ["src"], E = ["src"], $ = /* @__PURE__ */ f({
  name: "e-video",
  __name: "video",
  props: {
    src: {},
    webmSrc: {},
    poster: {},
    type: {},
    skeleton: { type: [Object, Boolean] },
    ratio: {},
    width: {},
    height: {},
    loop: { type: Boolean },
    muted: { type: Boolean },
    autoplay: { type: Boolean },
    controls: { type: Boolean }
  },
  setup(c) {
    const o = c, i = s(), { width: u } = B(i), r = s(), l = s(!1), h = y(() => {
      const { skeleton: e } = o;
      if (!e)
        return null;
      const t = {
        width: o.width,
        height: o.height
      };
      return o.ratio && !t.height && (t.height = `${u.value / o.ratio}`), typeof e == "boolean" ? t : {
        width: e.width ?? t.width,
        height: e.height ?? t.height
      };
    }), m = () => {
      l.value = !0;
    };
    return w(() => {
      r.value && (r.value.src = o.src, o.poster && (r.value.poster = o.poster));
    }), (e, t) => (n(), a("div", {
      ref_key: "wrapper",
      ref: i,
      class: "e-video"
    }, [
      p("video", {
        ref_key: "video",
        ref: r,
        loop: e.loop,
        muted: e.muted,
        autoplay: e.autoplay,
        width: e.width,
        height: e.height,
        poster: e.poster,
        controls: e.controls,
        onLoadeddata: m
      }, [
        e.webmSrc ? (n(), a("source", {
          key: 0,
          type: "video/webm",
          src: e.webmSrc
        }, null, 8, S)) : d("", !0),
        p("source", {
          type: "video/mp4",
          src: e.src
        }, null, 8, E),
        v(" Sorry, your browser doesn't support embedded videos. ")
      ], 40, P),
      e.skeleton && !l.value ? (n(), g(k(_), b({
        key: 0,
        class: "e-image__skeleton",
        icon: { icon: "image-fill" }
      }, h.value), null, 16)) : d("", !0)
    ], 512));
  }
});
export {
  $ as default
};
//# sourceMappingURL=video.js.map
